module.exports = __webpack_public_path__ + "static/Qld-blue-pumpkin-dip-518bd66a898f923e7a3f126d4db0fd2c.png";